import styled from "styled-components";
import { PRIMARY_COLORS } from "../../../../../../consts/colors";

export const StyledSlot = styled.div<{ statusColor: string | undefined }>`
   width: 100%;
   background-color: ${PRIMARY_COLORS.WHITE};
   margin-bottom: 10px;
   &:hover {
      .date {
         background-color: ${PRIMARY_COLORS.LINK_WATER} !important;
      }
      .wrapper,
      .actions {
         background-color: ${PRIMARY_COLORS.LILY_WHITE};
      }
   }

   .wrapper {
      width: 100%;
      display: flex;

      .date {
         width: 90px;
         background-color: ${PRIMARY_COLORS.AQUA_HAZE};
         border-radius: 3px;
         padding: 4px;
         border: 1px solid ${PRIMARY_COLORS.LIGHT_GREY};
         display: flex;
         flex-direction: column;
         justify-content: center;
         align-items: center;

         p {
            font-size: 20px !important;
            font-weight: bold;
         }

         p.month {
            text-transform: uppercase;
            font-size: 10pt !important;
         }
         p.day {
            font-size: 16pt !important;
         }
      }

      .details-section {
         width: calc(100% - 90px);
         border-radius: 5px;
         border: 1px solid ${PRIMARY_COLORS.LIGHT_GREY};
         padding: 10px 20px;

         .title {
            display: flex;
            gap: 8px;
            justify-content: space-between;
            align-items: flex-start;

            img {
               width: 20px;
               height: auto;
            }

            span {
               font-size: 14px !important;
               font-weight: bold;
            }
         }

         .sub-title {
            font-size: 13px !important;
            margin: 5px 0px;
            span {
               font-size: 12px !important;
            }
            
         }

         button {
            margin-top: 8px;
            padding: 6px 12px;
            background: ${PRIMARY_COLORS.FIRE_ENGINE_RED};
            color: white;
            border: none;
            border-radius: 4px;
            font-size: 13px;
         }
      }
   }
`;

export const StyledActions = styled.div``;
